import { Card, CardContent, Typography } from "@material-ui/core";
import React from "react";

const CountWidget = ({ data }) => {
  return (
    <Card>
      <CardContent>
        <Typography variant="h6">{data?.title}</Typography>
        <Typography variant="h4">{data?.value}</Typography>
      </CardContent>
    </Card>
  );
};

export default CountWidget;
